import type { FaireProductEntity } from "../../entity_types/product";

export const p_nb2s54h26m: FaireProductEntity = {
  token: "p_nb2s54h26m",
  type: "product",
  name: "Oversized Knit Cardigan with Denim Panels",
  brandToken: "b_qcqvf6ftyr",
  brandName: "AZSHOP Trading LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/1a5cf751d6d4034ad5447012b695dededd9631c447489f6d3330fdc05738b8a6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d0e1edf7f973611737a46ced305a591374118a4302563b7c95ca3b29d1e56dbd.jpeg",
    "https://cdn.faire.com/fastly/a82e8061b5dfdb2a82c3b13141d79dcfede8d7f026a705b714999739c319f820.jpeg",
    "https://cdn.faire.com/fastly/12934daa9433506dafccc7fbe6147206c27c855a6e2fc8c25687db096b2a9a8f.jpeg",
    "https://cdn.faire.com/fastly/28bb06887e7bf9630fadd9d85c1b3e98774897f576084431171b5b9861d9433e.jpeg",
    "https://cdn.faire.com/fastly/40e60ea47b80e80f6c3a3c31b9f26926cd83af1cd38f82cee5fc454c7ea2886b.jpeg",
  ],
  priceDollars: 37.99,
  description:
    "Oversized knit cardigan with denim panel accents. Button-up front with large pockets. A unique layering piece for cool weather.\n\nFabric: 100% acrylic\nWeight: 2.86 lb",
  tags: [],
  msrpDollars: 75.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:26.654Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
